import React, { useState } from 'react';
import { Title } from 'react-admin';
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  Card,
  CardContent
} from '@material-ui/core';
import { FolderOpen } from '@material-ui/icons';
import labels from '../../labels';
import ManageView from './components/ManageView';
import CsvEditor from './components/CsvEditor/CsvEditor';
import { useApi } from './api';
import useFirebaseToken from '../../bitComponents/utils/hooks/useFirebaseToken';
import ErrorBoundary from '../../ErrorBoundry';

const Manage = () => {
  const { token } = useFirebaseToken();
  const [isManageViewOpen, setIsManageViewOpen] = useState(false);
  const {
    syncBqToPgNames,
    download,
    uploadCsv,
    downloadCsvString,
    uploadCsvString
  } = useApi('/car-names', token);

  if (!token) return <></>;
  return (
    <>
      <Title title={labels.carNameManagement}>ניהול שמות רכב</Title>
      <Card
        style={{
          backgroundColor: 'white',
          borderRadius: 8,
          marginTop: 20,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          overflow: 'visible'
        }}
      >
        <CardContent style={{ padding: '24px' }}>
          <Box style={{ marginBottom: '24px', padding: '16px 0' }}>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Typography
                variant="h4"
                style={{ fontWeight: 600, color: '#2c3e50' }}
              >
                ניהול שמות רכבים
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<FolderOpen />}
                onClick={() => setIsManageViewOpen(true)}
                style={{
                  borderRadius: 8,
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                ניהול מבוסס קבצים
              </Button>
            </Box>
          </Box>
          <ErrorBoundary
            fallback={
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>שגיאה בטעינת העורך</h2>
                <p>
                  אירעה שגיאה בטעינת עורך ה-CSV. אנא רענן את הדף או פנה לתמיכה.
                </p>
              </div>
            }
          >
            <CsvEditor
              downloadCsvString={downloadCsvString}
              uploadCsvString={uploadCsvString}
              syncBqToPgNames={syncBqToPgNames}
            />
          </ErrorBoundary>
        </CardContent>
      </Card>

      <Dialog
        open={isManageViewOpen}
        onClose={() => setIsManageViewOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            maxHeight: '90vh',
            overflow: 'auto'
          }
        }}
      >
        <DialogContent style={{ padding: 0 }}>
          <ManageView
            syncBqToPgNames={syncBqToPgNames}
            download={download}
            uploadCsv={uploadCsv}
            resourceName="שמות רכבים"
            title={'ניהול שמות רכבים'}
            subtitle={'ייצוא, העלאה וסנכרון שמות רכבים'}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Manage;
